export default __webpack_public_path__ + "static/media/1.558998fa.jpg";